/**
 * T144: Form Error Display component
 * Shows form validation errors in user-friendly format
 */

import React from 'react';
import { Alert, List } from 'antd';
import { ExclamationOutlined } from '@ant-design/icons';

export interface FormErrorsProps {
  errors?: Record<string, string>;
  message?: string;
  showIcon?: boolean;
  closable?: boolean;
}

/**
 * Component to display form validation errors
 */
export const FormErrors: React.FC<FormErrorsProps> = ({
  errors = {},
  message,
  showIcon = true,
  closable = false,
}) => {
  const errorList = Object.entries(errors).map(([field, error]) => ({
    key: field,
    field,
    message: error,
  }));

  if (!message && errorList.length === 0) {
    return null;
  }

  if (errorList.length === 0 && message) {
    return (
      <Alert
        message="Erro"
        description={message}
        type="error"
        showIcon={showIcon}
        icon={<ExclamationOutlined />}
        closable={closable}
        className="mb-4"
      />
    );
  }

  return (
    <Alert
      message="Verifique os erros abaixo"
      type="error"
      showIcon={showIcon}
      icon={<ExclamationOutlined />}
      closable={closable}
      className="mb-4"
      description={
        <List
          size="small"
          dataSource={errorList}
          renderItem={(item) => (
            <List.Item className="!px-0 !py-1">
              <span className="text-red-700">
                <strong>{item.field}:</strong> {item.message}
              </span>
            </List.Item>
          )}
        />
      }
    />
  );
};

export default FormErrors;
